module.exports = __webpack_public_path__ + "img/close-popup.690427ae.svg";